module.exports = __webpack_public_path__ + "static/media/Santana.2b429ce8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Santana.eot
// module id = 2973
// module chunks = 68